import Cart from './Cart'
import CartDom from './CartDom'
import Dom from './Dom'
import App from './App'
import GraphQL from './GraphQL'

class CatalogClass {
    constructor() {
        window.addEventListener('scroll', this.handleSetCatalogImage)
        document.addEventListener('DOMContentLoaded', this.handleSetCatalogImage)
        document.addEventListener('DOMContentLoaded', this.handleSetCatalogImages)
        document.addEventListener('DOMContentLoaded', this.setCatalogMenuEvents)
        document.addEventListener('DOMContentLoaded', this.setCatalogSmallImagesNav)
        document.addEventListener('DOMContentLoaded', this.setYoutubeLinks)
        document.addEventListener('DOMContentLoaded', this.setFavoriteEvents)
        document.addEventListener('DOMContentLoaded', this.setElementFavorite)

        document.addEventListener('keydown', (e) => {
            let isEscape = false

            if ("key" in e) {
                isEscape = (e.key === "Escape" || e.key === "Esc")
            } else {
                isEscape = (e.keyCode === 27)
            }

            if (isEscape) {
                App.runCallback('show_youtube_link', null)
            }
        })
    }

    setCatalogElementEvents() {
        document.querySelectorAll('.catalog-product__quantity .input-number__increment_plus').forEach((btn) => [
            btn.addEventListener('click', (e) => {
                const target = e.target,
                input = target.parentNode.querySelector('.input-number__count')

                let value = parseInt(input.value)

                value++

                if (!value) {
                    value = 1
                }

                input.value = value
            })
        ])
        
        document.querySelectorAll('.catalog-product__quantity .input-number__increment_minus').forEach((btn) => [
            btn.addEventListener('click', (e) => {
                const target = e.target,
                input = target.parentNode.querySelector('.input-number__count')

                let value = parseInt(input.value)

                value--

                if (value < 0 || !value) {
                    value = 1
                }

                input.value = value
            })
        ])
    }

    setCatalogMenuEvents() {
        document.querySelectorAll('.catalog__menu-link').forEach((link) => {
            const parent = link.parentNode
        
            if (parent.classList.contains('catalog__menu-item_sub')) {
                link.addEventListener('click', (e) => {
                    if (!parent.classList.contains('catalog__menu-item_active')) {
                        e.preventDefault()
                        
                        parent.classList.toggle('catalog__menu-item_active')
            
                        return false
                    }
                })
            }
        })
    }

    setElementFavorite() {
        const elementFavorite = document.querySelector('.catalog-product__favorite')

        if (elementFavorite) {
            elementFavorite.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()

                const id = parseInt(elementFavorite.getAttribute('data-id'))

                if (id > 0) {
                    elementFavorite.classList[(elementFavorite.classList.contains('catalog-product__favorite_active')) ? 'remove' : 'add']('catalog-product__favorite_active')

                    Catalog.addFavorite((err, res) => {
                        if (res) {
                            
                        } else {

                        }
                    }, id)
                }

                return false
            })
        }
    }

    setFavoriteEvents() {
        document.querySelectorAll('.product-card').forEach((productCard) => {
            const productCardFavorite = productCard.querySelector('.product-card__wish-list')

            if (productCardFavorite) {
                productCardFavorite.addEventListener('click', (e) => {
                    e.preventDefault()

                    const id = parseInt(productCardFavorite.getAttribute('data-id'))

                    if (id > 0) {
                        productCardFavorite.classList[(productCardFavorite.classList.contains('product-card__wish-list_active')) ? 'remove' : 'add']('product-card__wish-list_active')

                        Catalog.addFavorite((err, res) => {
                            if (res) {
                                
                            } else {

                            }
                        }, id)
                    }

                    return false
                })
            }
        })
    }

    setYoutubeLinks() {
        document.querySelectorAll('.product-card').forEach((productCard) => {
            const productCardYoutube = productCard.querySelector('.product-card__youtube')

            if (productCardYoutube) {
                productCardYoutube.addEventListener('click', (e) => {
                    e.preventDefault()

                    const link = productCardYoutube.getAttribute('data-src')

                    App.runCallback('show_youtube_link', link)

                    return false
                })
            }
        })

        /*
        const imageLinkYoutube = document.querySelector('.catalog-product__small-image-link_youtube')

        if (imageLinkYoutube) {
            imageLinkYoutube.addEventListener('click', (e) => {
                e.preventDefault()

                const link = imageLinkYoutube.getAttribute('href')

                App.runCallback('show_youtube_link', link)

                return false
            })
        }
        */
    }

    setCatalogSmallImagesNav() {
        document.querySelectorAll('.product-card').forEach((productCard) => {
            if (productCard.querySelector('.product-card__navs')) {
                let current = 1,
                count = productCard.querySelector('.product-card__small-images').querySelectorAll('.product-card__small-image').length

                const navImages = (e, isNext) => {
                    e.preventDefault()

                    let photoEl = null

                    if (isNext) {
                        photoEl = productCard.querySelector('.product-card__small-images').querySelectorAll('.product-card__small-image')[current]

                        if (!photoEl) {
                            photoEl = productCard.querySelector('.product-card__small-images').querySelectorAll('.product-card__small-image')[0]

                            current = 1
                        } else {
                            current++
                        }
                    } else {
                        current--

                        if (current <= 0) {
                            current = count
                        }

                        photoEl = productCard.querySelector('.product-card__small-images').querySelectorAll('.product-card__small-image')[current - 1]
                    }

                    if (photoEl) {
                        productCard.querySelector('.product-card__image').style.backgroundImage = photoEl.style.backgroundImage
                    }

                    return false
                }

                productCard.querySelector('.product-card__nav_prev').addEventListener('click', (e) => {
                    navImages(e, false)
                })

                productCard.querySelector('.product-card__nav_next').addEventListener('click', (e) => {
                    navImages(e, true)
                })
            }
        })
    }

    setCatalogAddCartEvents(selector) {
        document.querySelectorAll((selector ? selector + ' ' : '') + '.button-add-cart').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const target = e.target,
                PRODUCT_ID = parseInt(target.getAttribute('data-id'))
        
                if (target.classList.contains('button_is-cart')) {
                    document.location = Cart.url
                } else {
                    target.classList.add('button_is-cart')
                    target.textContent = 'В корзине'

                    const catalogProductCount = document.querySelector('#product-count'),
                    QUANTITY = catalogProductCount ? parseInt(catalogProductCount.value) || 1 : 1
        
                    Cart.add(PRODUCT_ID, QUANTITY, (err, res) => {
                        CartDom.reset()
                    })
                }
            })
        })
    }

    handleSetCatalogImage() {
        const catalogImage = document.querySelector('.catalog-product__images-block')

        if (catalogImage) {
            if (window.innerWidth > 980) {
                const header = document.querySelector('.page__body-header'),
                panel = document.querySelector('#bx-panel'),
                catalogProduct = document.querySelector('.catalog-product'),
                iTop = Dom.getOffsetSum(catalogImage).top,
                wTop = window.scrollY,
                kTop = (header.offsetHeight || 0) + (panel.offsetHeight || 0),
                pTop = 107,
                diff = (wTop + catalogImage.offsetHeight) - (catalogProduct.offsetHeight + kTop)
        
                catalogImage.style.left = `${ catalogProduct.offsetLeft }px`
                catalogImage.style.width = `${ catalogImage.offsetWidth }px`
                catalogImage.style.height = `${ catalogImage.offsetWidth }px`
        
                if (wTop >= (kTop + pTop)) {
                    catalogImage.classList.add('catalog-product__images-link_fixed')
                    catalogImage.style.top = `${ 0 }px`
                } else {
                    catalogImage.classList.remove('catalog-product__images-link_fixed')
                    catalogImage.style.top = null
                    catalogImage.style.left = null
                    catalogImage.style.width = null
                    catalogImage.style.height = null
                }
        
                if (diff > 0) {
                    catalogImage.style.top = `${ -1 * diff }px`
                }
            } else {
                catalogImage.classList.remove('catalog-product__images-link_fixed')
                catalogImage.style.top = null
                catalogImage.style.left = null
                catalogImage.style.width = null
                catalogImage.style.height = null
            }
        }
    }

    handleSetCatalogImages() {
        const catalogImageLink = document.querySelector('.catalog-product__images-link')

        if (catalogImageLink) {
            catalogImageLink.addEventListener('click', (e) => {
                e.preventDefault()

                if (fsLightboxInstances['catalog-product-small-images'] && fsLightboxInstances['catalog-product-small-images'].elements.a.length > 0) {
                    fsLightboxInstances['catalog-product-small-images'].open(0)
                }

                return false
            })
        }

        document.querySelectorAll('.catalog-product__small-image').forEach((smallImage) => {
            smallImage.addEventListener('click', (e) => {
                e.preventDefault()

                document.querySelectorAll('.catalog-product__small-image-link_selected').forEach((selectedSmallImage) => {
                    selectedSmallImage.classList.remove('catalog-product__small-image-link_selected')
                })

                e.target.classList.add('catalog-product__small-image-link_selected')

                //catalogImageLink.style.backgroundImage = `url('${ e.target.getAttribute('href') }')`

                return false
            })
        })
    }

    //GraphQL
    addFavorite(cb, ID, fields={ }) {
        GraphQL.query('catalog_add_favorite', {
            'ID : Int!' : ID,
        }, fields, cb)
    }
}

const Catalog = new CatalogClass()

export default Catalog